import { useCallback, useContext } from 'react';
import dataRoomApi from 'router/subrouters/DataRoom/dataRoomApi';
import { ActiveSuggestedAction } from 'router/subrouters/DataRoom/models/Dashboard';
import DataRoomContext from 'router/subrouters/DataRoom/providers/DataRoom/DataRoom.context';
import { useTranslation } from 'react-i18next';
import {
  ACTIONED_SUGGESTED_ACTION_ACTION,
  ACTIONED_SUGGESTED_ACTION_NAME,
} from '../data';

export default function useActionedSuggestedAction() {
  const {
    dataRoom: { _id: dataRoomId },
  } = useContext(DataRoomContext);

  const { t } = useTranslation();

  return useCallback(
    async (suggestion: ActiveSuggestedAction) => {
      if (!dataRoomId || !suggestion) return;

      const { type, count = 1 } = suggestion || {};

      const suggestionNameKey = ACTIONED_SUGGESTED_ACTION_NAME[type];
      const suggestionActionKey = ACTIONED_SUGGESTED_ACTION_ACTION[type];

      try {
        await dataRoomApi.room.actionedSuggestedAction(dataRoomId, {
          suggestionName: t(suggestionNameKey, { count }),
          suggestionAction: t(suggestionActionKey, { count }),
        });
      } catch {
        return;
      }
    },
    [dataRoomId, t],
  );
}
